export var findCommunicationChartLinkBetween = function (links, nodeIdA, nodeIdB) {
    return links.find(function (link) {
        return (link.sourceNodeId === nodeIdA && link.targetNodeId === nodeIdB) ||
            (link.sourceNodeId === nodeIdB && link.targetNodeId === nodeIdA);
    });
};
